(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);

  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));

        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  /*
   * Custom desktop grid controls
   * 1st icon = 3 columns
   * 2nd icon = 4 columns
   * 3rd icon = 6 columns
   */
  const setupCustomDesktopGrid = () => {
    document.querySelectorAll('.column-options').forEach((fieldset) => {
      const inputs = fieldset.querySelectorAll('input[name="grid"]');

      if (!inputs.length) return;

      const defaultInput = fieldset.querySelector(
        'input[name="grid"][value="default"]'
      );

      const zoomInput =
        fieldset.querySelector(
          'input[name="grid"][value="zoom-out"]'
        ) ||
        fieldset.querySelector(
          'input[name="grid"][value="four-columns"]'
        );

      if (!defaultInput) return;

      /* Make Horizon's native second option our 4-column option. */
      if (zoomInput) {
        zoomInput.value = 'four-columns';
        zoomInput.setAttribute('aria-label', '4 columns');
        zoomInput.dataset.customGrid = '4';
      }

      /*
       * Exact SVG icons requested by the user.
       */
      const icon3 = `
        <svg role="presentation" width="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">
          <path fill="currentColor" d="M0 0h8v8H0zM0 10h8v8H0zM10 0h8v8h-8zM10 10h8v8h-8z"></path>
        </svg>
      `;

      const icon4 = `
        <svg role="presentation" width="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">
          <path fill="currentColor" d="M0 0h4v4H0zM0 7h4v4H0zM0 14h4v4H0zM7 0h4v4H7zM7 7h4v4H7zM7 14h4v4H7zM14 0h4v4h-4zM14 7h4v4h-4zM14 14h4v4h-4z"></path>
        </svg>
      `;

      const icon6 = `
        <svg role="presentation" width="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">
          <path fill="currentColor" d="M0 0h18v2H0zm0 4h18v2H0zm0 4h18v2H0zm0 4h18v2H0zm0 4h18v2H0z"></path>
        </svg>
      `;

      const getOptionLabel = (input) =>
        input ? input.closest('label') : null;

      const setIcon = (input, svg, columns, value) => {
        if (!input) return;

        const label = getOptionLabel(input);
        if (!label) return;

        label.dataset.customGridOption = columns;
        input.value = value;
        input.setAttribute('aria-label', `${columns} columns`);

        let iconWrapper = label.querySelector(
          '[data-custom-grid-icon]'
        );

        if (!iconWrapper) {
          iconWrapper = document.createElement('span');
          iconWrapper.setAttribute('data-custom-grid-icon', '');
          iconWrapper.className = 'custom-grid-icon';

          label.appendChild(iconWrapper);
        }

        iconWrapper.innerHTML = svg;
      };

      /* First = 3 columns */
      setIcon(
        defaultInput,
        icon3,
        '3',
        'default'
      );

      /* Second = 4 columns */
      setIcon(
        zoomInput,
        icon4,
        '4',
        'four-columns'
      );

      /* Create third = 6 columns */
      let sixInput = fieldset.querySelector(
        'input[name="grid"][value="six-columns"]'
      );

      if (!sixInput) {
        const sixLabel = document.createElement('label');
        sixLabel.className = 'column-options__option';
        sixLabel.dataset.customGridOption = '6';

        sixInput = document.createElement('input');
        sixInput.type = 'radio';
        sixInput.name = 'grid';
        sixInput.value = 'six-columns';
        sixInput.className = 'column-options__option-input';
        sixInput.setAttribute('aria-label', '6 columns');

        const sixIcon = document.createElement('span');
        sixIcon.className = 'custom-grid-icon';
        sixIcon.setAttribute('data-custom-grid-icon', '');
        sixIcon.innerHTML = icon6;

        sixLabel.appendChild(sixInput);
        sixLabel.appendChild(sixIcon);
        fieldset.appendChild(sixLabel);
      } else {
        setIcon(
          sixInput,
          icon6,
          '6',
          'six-columns'
        );
      }

      /*
       * Apply the actual grid view.
       * This does not depend on Horizon's zoom-out styling.
       */
      const applyGrid = (input) => {
        if (!input) return;

        const grid = document.querySelector(
          '.product-grid--{{ section.id }}'
        );

        if (!grid) return;

        let view = input.value;

        if (view === 'default') {
          view = 'default';
        } else if (view === 'four-columns') {
          view = 'four-columns';
        } else if (view === 'six-columns') {
          view = 'six-columns';
        }

        grid.setAttribute('product-grid-view', view);

        if (window.innerWidth >= 750) {
          sessionStorage.setItem(
            'product-grid-view-desktop',
            view
          );
        }

        fieldset
          .querySelectorAll('input[name="grid"]')
          .forEach((option) => {
            option.checked = option === input;
          });
      };

      /*
       * Add our handler after Horizon's controls exist.
       * It safely applies the custom state after the native handler.
       */
      [defaultInput, zoomInput, sixInput]
        .filter(Boolean)
        .forEach((input) => {
          if (input.dataset.customGridListener === 'true') return;

          input.dataset.customGridListener = 'true';

          input.addEventListener('change', () => {
            window.requestAnimationFrame(() => {
              applyGrid(input);
            });
          });
        });

      /*
       * Restore the selected desktop grid.
       */
      if (window.innerWidth >= 750) {
        const savedView = sessionStorage.getItem(
          'product-grid-view-desktop'
        );

        const savedInput = fieldset.querySelector(
          `input[name="grid"][value="${savedView}"]`
        );

        if (savedInput) {
          savedInput.checked = true;

          window.requestAnimationFrame(() => {
            applyGrid(savedInput);
          });
        }
      }
    });
  };

  /* =========================================================
     MOBILE COLLECTION TOOLBAR
     Mobile order:
     FILTER | SORT BY | GRID ICONS
     ========================================================= */

  let customMobileToolbarUpdating = false;

  const setMobileGridIcons = () => {
    const mobileGrid = document.querySelector(
      '.facets-toggle.custom-mobile-toolbar .grid-density-controls'
    );

    if (!mobileGrid) return;

    /* Mobile-only icons: 2-column and 3-column */
    const mobileIcon2 = `
      <svg role="presentation" width="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">
        <path fill="currentColor" d="M0 0h7v7H0zM11 0h7v7h-7zM0 11h7v7H0zM11 11h7v7h-7z"></path>
      </svg>
    `;

    const mobileIcon3 = `
      <svg role="presentation" width="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">
        <path fill="currentColor" d="M0 0h4v4H0zM7 0h4v4H7zM14 0h4v4h-4zM0 7h4v4H0zM7 7h4v4H7zM14 7h4v4h-4zM0 14h4v4H0zM7 14h4v4H7zM14 14h4v4h-4z"></path>
      </svg>
    `;

    const options = mobileGrid.querySelectorAll(
      '.column-options__option'
    );

    options.forEach((option, index) => {
      if (index > 1) return;

      const icon = option.querySelector('.custom-grid-icon');
      if (!icon) return;

      icon.innerHTML = index === 0 ? mobileIcon2 : mobileIcon3;
      option.dataset.mobileGridIcon = index === 0 ? '2' : '3';
    });
  };

  const setupMobileCollectionToolbar = () => {
    if (customMobileToolbarUpdating) return;

    const isMobile = window.innerWidth <= 749;
    const toggles = document.querySelectorAll('.facets-toggle');

    if (!toggles.length) return;

    customMobileToolbarUpdating = true;

    try {
      toggles.forEach((toggle) => {
        const mobileWrapper = toggle.querySelector('.facets-mobile-wrapper');
        const horizontalToolbar = document.querySelector(
          '.facets.facets--horizontal.facets-controls-wrapper'
        );

        if (!mobileWrapper || !horizontalToolbar) return;

        const sorting = horizontalToolbar.querySelector('.sorting-filter');

        if (isMobile) {
          toggle.classList.add('custom-mobile-toolbar');

          if (sorting && sorting.parentNode !== mobileWrapper) {
            if (!sorting.dataset.customMobileOriginal) {
              sorting._customMobileOriginalParent = sorting.parentNode;
              sorting._customMobileOriginalNextSibling = sorting.nextSibling;
              sorting.dataset.customMobileOriginal = 'true';
            }

            mobileWrapper.insertBefore(sorting, mobileWrapper.firstChild);
          }
        } else {
          toggle.classList.remove('custom-mobile-toolbar');

          if (
            sorting &&
            sorting.dataset.customMobileOriginal === 'true' &&
            sorting.parentNode === mobileWrapper
          ) {
            const originalParent = sorting._customMobileOriginalParent;
            const originalNextSibling = sorting._customMobileOriginalNextSibling;

            if (originalParent) {
              if (
                originalNextSibling &&
                originalNextSibling.parentNode === originalParent
              ) {
                originalParent.insertBefore(sorting, originalNextSibling);
              } else {
                originalParent.appendChild(sorting);
              }
            }
          }
        }
      });

      setMobileGridIcons();
    } finally {
      window.requestAnimationFrame(() => {
        customMobileToolbarUpdating = false;
      });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      setupMobileCollectionToolbar,
      { once: true }
    );
  } else {
    setupMobileCollectionToolbar();
  }

  const initCustomDesktopGrid = () => {
    setupCustomDesktopGrid();
    setupMobileCollectionToolbar();
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initCustomDesktopGrid,
      { once: true }
    );
  } else {
    initCustomDesktopGrid();
  }

  const customGridObserver = new MutationObserver(() => {
    setupCustomDesktopGrid();
    setupMobileCollectionToolbar();
  });

  if (document.body) {
    customGridObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function init(root) {
      if (root.dataset.hsReady) return;
      root.dataset.hsReady = 'true';

      var track = root.querySelector('[data-hs-track]');
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-hs-slide]'));
      var prev = root.querySelector('[data-hs-prev]');
      var next = root.querySelector('[data-hs-next]');
      var dotsWrap = root.querySelector('[data-hs-dots]');
      var pauseBtn = root.querySelector('[data-hs-pause]');
      var mode = root.dataset.transition;
      // Reduced-motion only stops the slide rotation. Muted background videos still play,
      // because many phones (battery saver / "remove animations") report reduced-motion = true.
      var autoplay = root.dataset.autoplay === 'true' && !reduceMotion;
      var interval = (parseInt(root.dataset.interval, 10) || 6) * 1000;
      var n = slides.length;
      var index = 0;
      var timer = null;
      var userPaused = false;
      var editorHold = false;
      var inView = true;
      var dots = [];

      if (!track || !n) return;

      /* ---------- Video helpers ---------- */

      // video is really visible (not display:none from the desktop/mobile switch)
      function isRendered(v) {
        return v.getClientRects().length > 0;
      }

      function shouldPlay(v) {
        var slide = v.closest('[data-hs-slide]');
        return !!slide && slide.classList.contains('is-active') && isRendered(v) && inView && !document.hidden;
      }

      function attemptPlay(v) {
        var p;
        try { p = v.play(); } catch (e) { return; }
        if (p && p.catch) p.catch(function () { /* blocked: will retry on data / user touch */ });
      }

      // iOS and some Android browsers need these as real DOM attributes, not only JS properties
      function prepVideo(v) {
        v.muted = true;
        v.defaultMuted = true;
        v.playsInline = true;
        v.loop = true;
        v.setAttribute('muted', '');
        v.setAttribute('playsinline', '');
        v.setAttribute('webkit-playsinline', '');
        v.setAttribute('disablepictureinpicture', '');
        v.setAttribute('disableremoteplayback', '');
        v.removeAttribute('controls');
        if (v.preload !== 'auto') v.preload = 'auto';

        if (!v.dataset.hsBound) {
          v.dataset.hsBound = 'true';
          var resume = function () {
            if (v.paused && shouldPlay(v)) attemptPlay(v);
          };
          // play as soon as enough data has loaded (slow networks)
          v.addEventListener('loadeddata', resume);
          v.addEventListener('canplay', resume);
          // if the browser / OS pauses it by itself, start it again
          v.addEventListener('pause', function () { setTimeout(resume, 250); });
        }
      }

      function playVideo(slide) {
        var vids = slide.querySelectorAll('video');
        Array.prototype.forEach.call(vids, function (v) {
          if (!isRendered(v)) {
            // hidden by CSS (desktop/mobile switch) -> pause it
            if (!v.paused) v.pause();
            return;
          }
          prepVideo(v);
          if (inView && !document.hidden) attemptPlay(v);
        });
      }

      function pauseVideo(slide) {
        var vids = slide.querySelectorAll('video');
        Array.prototype.forEach.call(vids, function (v) {
          if (!v.paused) v.pause();
        });
      }

      // iOS Low Power Mode / data saver: autoplay is blocked until the first real touch.
      // touchend / click / pointerup count as a user gesture (touchstart does not).
      function unlock() {
        if (!root.isConnected) return;
        var s = slides[index];
        if (!s) return;
        var vids = s.querySelectorAll('video');
        Array.prototype.forEach.call(vids, function (v) {
          if (v.paused && isRendered(v)) {
            prepVideo(v);
            attemptPlay(v);
          }
        });
      }
      ['touchend', 'pointerup', 'click', 'keydown'].forEach(function (type) {
        document.addEventListener(type, unlock, { passive: true });
      });

      // Play only while the slider is on screen (saves battery, keeps it working after scroll)
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          inView = entries[0].isIntersecting;
          if (!slides[index]) return;
          if (inView) playVideo(slides[index]); else pauseVideo(slides[index]);
        }, { threshold: 0.2 }).observe(root);
      }

      // Screen size changed (rotate / resize): switch to the right video
      var resizeTimer;
      function onResize() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          if (slides[index]) playVideo(slides[index]);
        }, 200);
      }
      window.addEventListener('resize', onResize);
      window.addEventListener('orientationchange', onResize);

      // Coming back from another app / tab / back-forward cache
      window.addEventListener('pageshow', function () {
        if (slides[index]) playVideo(slides[index]);
      });
      window.addEventListener('load', function () {
        if (slides[index]) playVideo(slides[index]);
      });

      /* ---------- Slider ---------- */

      function show(i) {
        index = (i + n) % n;
        if (mode === 'slide') track.style.transform = 'translateX(-' + index * 100 + '%)';
        slides.forEach(function (s, k) {
          var on = k === index;
          s.classList.toggle('is-active', on);
          s.setAttribute('aria-hidden', on ? 'false' : 'true');
          if (on) { s.removeAttribute('inert'); playVideo(s); }
          else { s.setAttribute('inert', ''); pauseVideo(s); }
        });
        dots.forEach(function (d, k) {
          d.classList.toggle('is-active', k === index);
          d.setAttribute('aria-selected', k === index ? 'true' : 'false');
        });
      }

      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function start() {
        stop();
        if (!autoplay || userPaused || editorHold || n < 2) return;
        timer = setInterval(function () {
          if (!root.isConnected) { stop(); return; }
          show(index + 1);
        }, interval);
      }

      if (dotsWrap) {
        slides.forEach(function (_, k) {
          var d = document.createElement('button');
          d.type = 'button';
          d.className = 'hs__dot';
          d.setAttribute('role', 'tab');
          d.setAttribute('aria-label', 'Go to slide ' + (k + 1));
          d.addEventListener('click', function () { show(k); start(); });
          dotsWrap.appendChild(d);
          dots.push(d);
        });
      }

      if (prev) prev.addEventListener('click', function () { show(index - 1); start(); });
      if (next) next.addEventListener('click', function () { show(index + 1); start(); });

      if (pauseBtn) {
        pauseBtn.addEventListener('click', function () {
          userPaused = !userPaused;
          pauseBtn.classList.toggle('is-paused', userPaused);
          pauseBtn.setAttribute('aria-label', userPaused ? 'Play slideshow' : 'Pause slideshow');
          start();
        });
      }

      // Pause on hover only for a real mouse, not touch (iPhone fix)
      root.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') stop(); });
      root.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') start(); });
      // Pause on focus only for keyboard users (iPhone fix)
      root.addEventListener('focusin', function (e) {
        if (e.target.matches && e.target.matches(':focus-visible')) stop();
      });
      root.addEventListener('focusout', start);

      // Swipe
      var sx = 0, sy = 0;
      root.addEventListener('touchstart', function (e) {
        sx = e.changedTouches[0].clientX;
        sy = e.changedTouches[0].clientY;
      }, { passive: true });
      root.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - sx;
        var dy = e.changedTouches[0].clientY - sy;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
          show(dx < 0 ? index + 1 : index - 1);
          start();
        }
      }, { passive: true });

      // Keyboard
      root.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { show(index + 1); start(); }
        if (e.key === 'ArrowLeft') { show(index - 1); start(); }
      });

      // Stop when tab is hidden, resume video when visible again
      document.addEventListener('visibilitychange', function () {
        if (!root.isConnected) return;
        if (document.hidden) {
          stop();
        } else {
          start();
          if (slides[index]) playVideo(slides[index]);
        }
      });

      // Theme editor: jump to the selected slide
      root.addEventListener('shopify:block:select', function (e) {
        var k = slides.indexOf(e.target);
        if (k > -1) { editorHold = true; stop(); show(k); }
      });
      root.addEventListener('shopify:block:deselect', function () {
        editorHold = false; start();
      });

      show(0);
      start();
    }

    function initAll() {
      document.querySelectorAll('[data-hero-slider]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
